<script>
    import { GET, POST } from "../../components/communication.js";
    import { authToken, sessionStorageSet, sessionStorageRemove, flashErrorMessage, flashSuccessMessage }
        from "../../components/stores.js";
    import { navigate } from "svelte-routing";

    let login = { username: "", password: "" };
    async function handleSubmit(event) {
        sessionStorageRemove("authToken");
        authToken.set('');

        const response = POST("/C/authenticate", JSON.stringify(login));
        const data = await response;
        console.log("Response: ", response);
        if(data && data.token) {
            authToken.set(data.token);
            sessionStorageSet('authToken',data.token);
            navigate('/c/home', { replace: false });
            location.reload();
            flashSuccessMessage.set("Kirjautuminen onnistui. Tervetuloa Dynamosalin asiakasjärjestelmään!");
        } else {
            alert("Kirjautuminen epäonnistui");
            flashErrorMessage.set("Kirjautuminen epäonnistui. Kokeile uudestaan oikeilla tiedoilla.");
        }

    }
</script>

<div class="page row">
    <div class="col-sm-12 col-md-6 col-lg-6" style="margin-left:auto;margin-right:auto;">
        <div class="card">
            <h5 class="card-header">Kirjaudu sisään Dynamosalin asiakkaiden omaan järjestelmään</h5>
            <div class="card-body">
                <form on:submit|preventDefault={handleSubmit}>
                    <div class="form-group">
                        <label for="username">Sähköposti</label>
                        <input
                                class="form-control"
                                required
                                type="username"
                                id="username"
                                bind:value={login.username} />
                    </div>
                    <div class="form-group">
                        <label for="password">Salasana</label>
                        <input
                                class="form-control"
                                required
                                type="password"
                                id="password"
                                bind:value={login.password} />
                    </div>
                    <button type="submit" class="btn btn-primary">Kirjaudu</button>
                </form>
                <div>
                    <a href="/salasanaUnohtunut">Salasana unohtunut?</a>
                </div>
            </div>
        </div>
    </div>
</div>
